import React from 'react'
import Calendar2 from '../../Icons/Calendar2'
import './MyCalendarStyle.css'
import intl from 'react-intl-universal'
import '../../../components/myComponents/MyHeader/MyNavBar.css'
export default function MyCalendarDisable (props) {
  return (
    <div style={{ height: '30px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <div className={'leftContent'} style={{ display: 'flex', flexDirection: 'column', flex: 3, justifyContent: 'center', alignItems: 'center', height: '30px' }}>
        <div className={'left1 lt1-5'} style={{ fontSize: '0.8rem', width: '100%', padding: 0, height: '15px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center' }}>
          {intl.get('No ordering date')}
        </div>
      </div>
      <div className={'rightContent'} style={{ flex: 1, height: '30px', display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
        <Calendar2 height={'30px'} width={'30px'} />
      </div>
    </div>
  )
}
